<template>
  <b-form-group
    label="パスワード"
  >
    <b-form-input
      type="password"
      v-model="model"
    >
    </b-form-input>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/new',
      attribute: 'password'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
